import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"display":"block","margin-top":".3rem"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_button_loading_component = _resolveComponent("button-loading-component")!
  const _component_el_text = _resolveComponent("el-text")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_button_loading_component, {
      label: "Автопланирование работ",
      loading: _ctx.asyncOperationPending,
      disabled: !_ctx.order.jobs?.length || !_ctx.order.executiveEntityBranch?.id,
      onClick: _ctx.onAutoScheduleJobsClick
    }, null, 8, ["loading", "disabled", "onClick"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_text, {
        type: "info",
        size: "small"
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Начало планирования: " + _toDisplayString(_ctx.dateFormatter.dateTime(_ctx.order.scheduledStartDate, true, true, true, ', ')), 1)
        ]),
        _: 1
      })
    ])
  ]))
}